import { render, staticRenderFns } from "./driverprofilepicture.html?vue&type=template&id=3976c8e1&scoped=true&"
import script from "./driverprofilepicture.vue?vue&type=script&lang=js&"
export * from "./driverprofilepicture.vue?vue&type=script&lang=js&"
import style0 from "./driverprofilepicture.vue?vue&type=style&index=0&id=3976c8e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3976c8e1",
  null
  
)

export default component.exports